export default "__VITE_ASSET__CpM$0fQe__"